"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockStepDefinitions = void 0;
const z = require("zod");
exports.MockStepDefinitions = {
    MockOneInOneOutString: {
        type: 'MockOneInOneOutString',
        displayName: 'One in, one out',
        inputSchema: z.object({
            in1: z.string(),
        }),
        outputSchema: z.object({
            out1: z.string(),
        }),
    },
    MockOneInTwoOutString: {
        type: 'MockOneInTwoOutString',
        displayName: 'One in, two out',
        inputSchema: z.object({
            in1: z.string(),
        }),
        outputSchema: z.object({
            out1: z.string(),
            out2: z.string(),
        }),
    },
    MockTwoInOneOutString: {
        type: 'MockTwoInOneOutString',
        displayName: 'Two in, one out',
        inputSchema: z.object({
            in1: z.string(),
            in2: z.string(),
        }),
        outputSchema: z.object({
            out1: z.string(),
        }),
    },
    MockTwoInTwoOutString: {
        type: 'MockTwoInTwoOutString',
        displayName: 'Two in, two out',
        inputSchema: z.object({
            in1: z.string(),
            in2: z.string(),
        }),
        outputSchema: z.object({
            out1: z.string(),
            out2: z.string(),
        }),
    },
    MockTwoInOneOutNumber: {
        type: 'MockTwoInOneOutNumber',
        displayName: 'Two in, one out (number)',
        inputSchema: z.object({
            in1: z.number(),
            in2: z.number(),
        }),
        outputSchema: z.object({
            out1: z.number(),
        }),
    },
    MockComplexTypeInOut: {
        type: 'MockComplexTypeInOut',
        displayName: 'Complex type in, complex type out',
        inputSchema: z.object({
            obj: z.object({
                str: z.string(),
                num: z.number(),
            }),
            enum: z.enum(['a', 'b', 'c']),
            array: z.string().array(),
        }),
        outputSchema: z.object({
            obj: z.object({
                str: z.string(),
                array: z.string().array(),
            }),
        }),
    },
};
//# sourceMappingURL=mock-steps.js.map